import { inject, provideAppInitializer } from '@angular/core';

import { DpMeasurementSystemInitializer } from '../services/measurement-system-initializer';

export const initializeMeasurementSystem = (initializer: DpMeasurementSystemInitializer): (() => void) => {
  const result = (): void => {
    initializer.initialize();
  };
  return result;
};

export const measurementSystemInitializerProvider = provideAppInitializer(() => {
  const initializerFn = initializeMeasurementSystem(inject(DpMeasurementSystemInitializer));
  initializerFn();
});
